import { createContext, useContext, useState } from "react";

const DarkModeContext = createContext(undefined);

export const DarkModeProvider = ({ children }) => {
  // Quản lý state tập trung tại đây
  const [isDarkMode, setIsDarkMode] = useState("dark");

  return (
    // Truyền cả giá trị và hàm thay đổi giá trị vào Provider
    <DarkModeContext.Provider value={{ isDarkMode, setIsDarkMode }}>
      {children}
    </DarkModeContext.Provider>
  );
};

export const useDarkModeContext = () => {
  const context = useContext(DarkModeContext);
  if (!context) throw new Error("Phải dùng trong DarkModeProvider");
  return context;
};
